import type { HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react';

/** Back-office data table: scrolls sideways inside its card rather than the page. */
export function Table({ className = '', children, ...rest }: HTMLAttributes<HTMLTableElement>) {
  return (
    <div className="overflow-x-auto rounded-card border border-line">
      <table className={`w-full border-collapse text-left text-sm ${className}`} {...rest}>
        {children}
      </table>
    </div>
  );
}

export function Th({ className = '', ...rest }: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      scope="col"
      className={`whitespace-nowrap border-b border-line bg-surface px-3 py-2.5 text-xs font-semibold uppercase tracking-[0.04em] text-ink-muted ${className}`}
      {...rest}
    />
  );
}

export function Td({ className = '', ...rest }: TdHTMLAttributes<HTMLTableCellElement>) {
  return <td className={`border-b border-line px-3 py-2.5 align-middle ${className}`} {...rest} />;
}
